import type { CountryCode } from "@circle-react/types/Countries";

export const paywallKnowledgeBase = "https://help.circle.so/c/paywall-setup/";

export const formId = "stripe-onboarding-flow-v2";

// Countries supported by Stripe following the pattern ISO 3611-1 Alpha-2
// https://stripe.com/docs/connect/accounts
export const firstCountriesToBeShown: Array<Partial<CountryCode>> = [
  "US",
  "BR",
  "GB",
  "AU",
  "CA",
  "DE",
  "FR",
];

export const countriesNotSupported: Array<Partial<CountryCode>> = [
  "IN",
  "MY",
  "TH",
];

export const countriesToBeSorted: Array<Partial<CountryCode>> = [
  "AL",
  "AG",
  "AR",
  "AM",
  "AT",
  "BS",
  "BH",
  "BE",
  "BO",
  "BA",
  "BG",
  "KH",
  "CL",
  "CO",
  "CR",
  "CI",
  "HR",
  "CY",
  "CZ",
  "DK",
  "DO",
  "EC",
  "EG",
  "SV",
  "EE",
  "ET",
  "FI",
  "GM",
  "GH",
  "GR",
  "GT",
  "GY",
  "HK",
  "HU",
  "IS",
  "ID",
  "IE",
  "IL",
  "IT",
  "JM",
  "JP",
  "JO",
  "KE",
  "KW",
  "LV",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MT",
  "MU",
  "MD",
  "MN",
  "MX",
  "MA",
  "NA",
  "NL",
  "NZ",
  "NG",
  "MK",
  "NO",
  "OM",
  "PA",
  "PY",
  "PE",
  "PH",
  "PL",
  "PT",
  "QA",
  "RO",
  "RW",
  "SA",
  "SN",
  "RS",
  "SI",
  "SG",
  "SK",
  "ZA",
  "KR",
  "ES",
  "LK",
  "LC",
  "SE",
  "CH",
  "TW",
  "TZ",
  "TT",
  "TN",
  "TR",
  "AE",
  "UY",
  "UZ",
  "VN",
];
